import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import React from 'react';
import Logo from "../images/bordr-logo.svg"

const navigation = [
  { name: 'NIF', href: '/' },
  { name: 'Bank Account', href: '/bank' },
  { name: 'About Us', href: '/about' },
  { name: 'Contact', href: '/contact' },
]

export default function Header() {
  return (
    <header className="relative">
    {/* <div className="absolute inset-0">
        <div
        className="absolute inset-0 bg-pink-50"
        aria-hidden="true"
        />
    </div> */}
    <Popover as="div" className="relative z-10">
        {({ open }) => (
        <>
            <nav
            className="relative max-w-screen-xl mx-auto flex items-center justify-between pt-6 pb-2 px-4 sm:px-6 lg:px-8"
            aria-label="Global"
            >
            <div className="flex items-center justify-between w-full lg:w-auto">
                <a href="/">
                <span className="sr-only">Bordr</span>
                <img
                    className="h-14"
                    src={Logo}
                    alt="bordr logo"
                />
                </a>
                <div className="-mr-2 flex items-center lg:hidden">
                <Popover.Button className="bg-transaprent rounded-md p-2 inline-flex items-center justify-center text-gray-700 hover:bg-white focus:outline-none focus:ring-2 focus-ring-inset focus:ring-gray-500">
                    <span className="sr-only">Open main menu</span>
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                </Popover.Button>
                </div>
            </div>
            <div className="hidden space-x-10 lg:flex lg:ml-10">
                {navigation.map((item) => (
                <a
                    key={item.name}
                    href={item.href}
                    className="text-base font-medium text-gray-900 hover:text-gray-700"
                >
                    {item.name}
                </a>
                ))}
            </div>
            </nav>

            <Transition
            show={open}
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
            >
            <Popover.Panel
                focus
                static
                className="absolute top-0 inset-x-0 p-2 transition transform origin-top lg:hidden"
            >
                <div className="rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div className="px-5 pt-4 flex items-center justify-between">
                    <div>
                    <img
                        className="h-14"
                        src={Logo}
                        alt="bordr logo"
                    />
                    </div>
                    <div className="-mr-2">
                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-warm-gray-400 hover:bg-warm-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-500">
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                    </div>
                </div>
                <div className="pt-5 pb-6">
                    <div className="px-2 space-y-1">
                    {navigation.map((item) => (
                        <a
                        key={item.name}
                        href={item.href}
                        className="block px-3 py-2 rounded-md text-base font-medium text-warm-gray-900 hover:bg-warm-gray-50"
                        >
                        {item.name}
                        </a>
                    ))}
                    </div>
                </div>
                </div>
            </Popover.Panel>
            </Transition>
        </>
        )}
    </Popover>

    </header>
  )
}
